import MultiLoanApplicationFormModule from '.';
import { moduleActionContext } from '..';

// eslint-disable-next-line no-use-before-define
export const actionContext = (context: any) => moduleActionContext(context, MultiLoanApplicationFormModule);
